// This is commented out because our app uses a legacy version of boostrap. we can re-enable this when we move to the latest bootstrap.
//import 'bootstrap/dist/css/bootstrap.css';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import ReactGA from 'react-ga';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string;
const history = createBrowserHistory({ basename: baseUrl });

// Set up Google Analytics to track each route change in the history as a page view
const toxnotGoogleAnalyticsTrackingId = "UA-75430404-1";

ReactGA.initialize(toxnotGoogleAnalyticsTrackingId);

// track the current location as a pageview - the url this app is loading up in
ReactGA.set({ page: location.pathname });
ReactGA.pageview(location.pathname);

// track all in-app changes to the location (route) as a pageview
history.listen(location => {
    ReactGA.set({ page: location.pathname });
    ReactGA.pageview(location.pathname);
});

// Get the application-wide store instance, prepopulating with state from the server where available.
export const store = configureStore(history);

ReactDOM.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <App />
        </ConnectedRouter>
    </Provider>,
    document.getElementById('root'));

registerServiceWorker();